var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgOnOff = function SvgOnOff(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "On-Off",
    transform: "translate(-16 -12)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3144",
    "data-name": "Ellipse 3144",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(16 12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_on-off",
    d: "M13.208,1.717a7.821,7.821,0,0,1,3.355,6.41A7.938,7.938,0,0,1,8.579,16,7.956,7.956,0,0,1,.562,8.14,7.837,7.837,0,0,1,3.911,1.721a.784.784,0,0,1,1.129.244l.51.892a.754.754,0,0,1-.213.984A5.281,5.281,0,0,0,3.143,8.124,5.373,5.373,0,0,0,8.562,13.46a5.375,5.375,0,0,0,5.419-5.368,5.308,5.308,0,0,0-2.2-4.254.75.75,0,0,1-.21-.981l.51-.892a.78.78,0,0,1,1.123-.248ZM9.853,8.381V.762A.766.766,0,0,0,9.079,0H8.046a.766.766,0,0,0-.774.762V8.381a.766.766,0,0,0,.774.762H9.079A.766.766,0,0,0,9.853,8.381Z",
    transform: "translate(23.438 20)",
    fill: "#4c125a"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOnOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/on-off.42169187.svg";
export { ForwardRef as ReactComponent };